import CloseIcon from "@mui/icons-material/Close";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { Input, TextArea } from "../../../../../common/Input"; // ADDED

export function SalaryAdvanceViewModal({ isOpen, onClose, selectedSar }) {
  if (!isOpen || !selectedSar) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
  };

  const formatAmount = (n) =>
    Number(n ?? 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const isFinalized = ["Approved", "Processing", "Ongoing", "Completed"].includes(selectedSar.status);
  const displayApprovedAmount = isFinalized
    ? (selectedSar.approvedAmount ?? selectedSar.amount)
    : null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto"
    >
      <div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] xl:w-[40%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">

        {/* Header */}
        <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 flex items-center space-x-2">
            <AssignmentIcon className="text-customMainColor" fontSize="medium" />
            <span className="text-xl text-customMainColor">Request Details</span>
          </h2>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 transition-colors p-1 bg-transparent border-none cursor-pointer"
            aria-label="Close modal"
          >
            <CloseIcon fontSize="medium" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto flex-grow space-y-4">

          <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm pb-4 pt-2">
            <div className="py-1 border-b border-gray-300 mb-4">
              <h3 className="font-medium text-gray-700 uppercase text-xs tracking-widest">Application Information</h3>
            </div>

            {/* Grid for metadata */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
              <Input
                label="Reference Number"
                value={selectedSar.referenceNumber}
                isViewOnly={true}
              />
              <Input
                label="Employee Name"
                value={selectedSar.employeeFullName}
                isViewOnly={true}
              />
              <Input
                label="Requested Date"
                value={formatDate(selectedSar.requestedDate)}
                isViewOnly={true}
              />
              <Input
                label="Requested Amount"
                value={`₱${formatAmount(selectedSar.amount)}`}
                isViewOnly={true}
                className="font-bold"
              />
              <Input
                label="Approved Amount"
                value={
                  displayApprovedAmount !== null
                    ? `₱${formatAmount(displayApprovedAmount)}`
                    : "—"
                }
                isViewOnly={true}
                className="font-bold"
              />

              <Input
                label="Current Status"
                value={selectedSar.status?.toUpperCase()}
                isViewOnly={true}
                className="font-bold"
              />

              {selectedSar?.salaryTypeName && (
                <Input
                  label="Request Type"
                  value={selectedSar.salaryTypeName}
                  isViewOnly={true}
                />
              )}
            </div>

            {/* Reason Section */}
            <div className="mt-2">
              <TextArea
                label="Reason for Request"
                value={selectedSar.reason || "No reason provided."}
                isDisabled={true}
                rows={4}
              />
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="flex justify-end p-5 border-t border-gray-200 bg-white rounded-b-lg shadow-sm">
          <button
            onClick={onClose}
            className="bg-gray-400 hover:bg-gray-500 text-white px-8 py-2 rounded border-none cursor-pointer transition-colors font-medium"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}